import { useAppLocation } from "_graphql/cache/auth";

import { useOffer } from "hooks/data/use-offers";
import ReinsurerInterests from "./interests";
import ReinsurersList from "./reinsurers-list";

export default function OfferParticipation({
  isOfferPublished,
}: {
  isOfferPublished: boolean;
}) {
  const { params } = useAppLocation();
  const { loading, offer, refetch } = useOffer({
    offer_id: params.offer || "",
  });

  return (
    <div className="flex flex-col flex-1 overflow-y-auto p-4 sm:p-6 gap-6">
      {/* Reinsurers List Section */}
      <ReinsurersList offer={offer} refetch={refetch} loading={loading} />

      {/* Reinsurers Interest Section */}
      <ReinsurerInterests isOfferPublished={isOfferPublished} offer={offer} />
    </div>
  );
}
